<template>
    <div>
        <nav-breadcrumb :menu="[{label: personId ? '编辑代理人' : '新增代理人'}]"/>

        <el-row>
            <el-col>
                <panel label="基本信息">
                    <el-form :model="personForm" :rules="formRules" ref="personForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-form-item label="姓名：" prop="p__name" style="width: 60%" :rules="{required: true, message: '不能为空'}">
                                    <el-input v-model="personForm.p__name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="身份证号：" prop="p__IC" style="width: 60%" :rules="{required: true, message: '不能为空'}">
                                    <el-input v-model="personForm.p__IC"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="通讯地址：" prop="p__address" style="width: 60%" :rules="{required: true, message: '不能为空'}">
                                    <el-input v-model="personForm.p__address"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="邮编：" prop="p__postalCode" style="width: 60%" :rules="{required: true, message: '不能为空'}">
                                    <el-input v-model="personForm.p__postalCode"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="联系电话：" prop="p__contactNo" style="width: 60%" :rules="{required: true, message: '不能为空'}">
                                    <el-input v-model="personForm.p__contactNo"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </panel>
            </el-col>
        </el-row>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('personForm')">确认提交</el-button>
            <el-button @click="$router.back()">取消</el-button>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    export default {
        name: "ProxyPersonAdd",
        data(){
            return {
                personId: this.$route.query['personId']||'',
                personForm:{
                },
                formRules: {},
            }
        },
        mounted() {
            if(this.personId){
                this.getData()
            }
        },
        methods:{
            getData:function(){
                xhr.getProxyPerson({
                        'p.personId': this.personId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.personForm = res.data.data
                            }
                        }catch (e) {

                        }
                    })
            },
            onSubmit: function (formName) {
                let personForm = this.personForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        personForm.p__checked = true
                        xhr.updateProxyPerson(personForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.$router.push({
                                        name: 'ProxyPersonListView'
                                    })
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ProxyPersonAdd.vue